export const downloadCsvFromString = (fileAsString: string, fileName: string) => {
  // console.log("testing",fileAsString)
  const url = window.URL.createObjectURL(new Blob([fileAsString as BlobPart]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.csv`); //or any other extension
  document.body.appendChild(link);
  link.click();
};
